import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ChevronDown, Menu, X } from "lucide-react";

const solutionsLinks = [
  { to: "/criacao-de-sites", label: "Criação de Sites" },
  { to: "/ecommerce", label: "E-commerce" },
  { to: "/software-a-medida", label: "Software à Medida" },
  { to: "/automacao-empresarial", label: "Automação" },
  { to: "/inteligencia-artificial", label: "Inteligência Artificial" },
  { to: "/integracoes", label: "Integrações" },
];

const links = [
  { to: "/planos", label: "Planos" },
  { to: "/tech-partner", label: "Tech Partner" },
  { to: "/projetos", label: "Projetos" },
  { to: "/insights", label: "Insights" },
  { to: "/contacto", label: "Contacto" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all ${
        scrolled ? "bg-[#0a0a0a]" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-3 sm:py-4 flex items-center justify-between md:gap-10 lg:gap-14">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="font-display text-xl sm:text-2xl md:text-3xl text-white tracking-tight flex shrink-0 items-center gap-1 sm:gap-2"
        >
          <span className="inline-block w-2 h-2 sm:w-3 sm:h-3 bg-[#ff6b35] brutal-border" />
          <span className="text-sm sm:text-base">BEZIER<span className="text-[#ff6b35]">CLICK</span></span>
        </Link>

        <nav className="hidden md:flex flex-1 items-center justify-end gap-6 lg:gap-7">
          <div className="relative group">
            <NavLink
              to="/solucoes"
              data-testid="nav-solucoes"
              aria-haspopup="true"
              className="inline-flex items-center gap-1 font-mono text-xs uppercase tracking-widest text-white hover:text-[#ff6b35] transition-colors"
            >
              <span>Soluções</span>
              <ChevronDown size={14} className="shrink-0" />
            </NavLink>
            <div className="invisible absolute left-0 top-full z-50 w-64 pt-4 opacity-0 transition-all group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
              <div className="brutal-border bg-[#0a0a0a] p-3 shadow-[6px_6px_0_0_#ff6b35]">
                {solutionsLinks.map((l) => (
                  <NavLink
                    key={l.to}
                    to={l.to}
                    className="block px-3 py-3 font-mono text-[0.68rem] uppercase tracking-widest text-white hover:bg-[#ff6b35] hover:text-[#0a0a0a]"
                  >
                    {l.label}
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "")}`}
              className="font-mono text-xs uppercase tracking-widest text-white hover:text-[#ff6b35] transition-colors"
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            data-testid="nav-cta"
            to="/contacto"
            className="btn-brutal btn-brutal-orange !py-2 !px-4 text-xs"
          >
            Conte-nos o problema
          </Link>
        </nav>

        <button
          data-testid="navbar-toggle"
          className="md:hidden min-h-[44px] min-w-[44px] text-white p-2 brutal-border bg-[#ff6b35] inline-flex items-center justify-center"
          onClick={() => setOpen((s) => !s)}
          aria-label="Menu"
          aria-expanded={open}
          aria-controls="mobile-navigation"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          id="mobile-navigation"
          className="md:hidden bg-[#0a0a0a] border-t-4 border-[#ff6b35] px-5 pb-[calc(1.5rem+env(safe-area-inset-bottom))] pt-6 flex flex-col gap-3"
        >
          <NavLink
            to="/solucoes"
            onClick={() => setOpen(false)}
            className="font-display text-2xl text-white hover:text-[#ff6b35] min-h-[44px] flex items-center"
          >
            Soluções
          </NavLink>
          <div className="grid grid-cols-1 gap-1 border-l-4 border-[#ff6b35] pl-4">
            {solutionsLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="font-mono text-xs uppercase tracking-widest text-white/80 hover:text-[#ff6b35] min-h-[44px] flex items-center"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="font-display text-2xl text-white hover:text-[#ff6b35] min-h-[44px] flex items-center"
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contacto"
            onClick={() => setOpen(false)}
            className="btn-brutal btn-brutal-orange mt-2 min-h-[44px] w-full justify-center text-center"
          >
            Conte-nos o problema
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
